module.exports = "/images/paymaya-icon.png";